import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { MarqueeStrip } from "./components/Marquee";
import { Services } from "./components/Services";
import { Manifesto } from "./components/Manifesto";
import { Gallery } from "./components/Gallery";
import { Visit } from "./components/Visit";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.9 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        e.preventDefault();
        lenis.scrollTo(a.getAttribute("href"), { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <div className="App grain bg-ink min-h-screen">
      <Header />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <Manifesto />
        <Gallery />
        <Visit />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
